<template>
  <v-row dense>
    <v-col>
      <v-card>
        <v-container fluid>
          <v-row dense>
            <v-col class="font-weight-bold text-body-2" cols="auto">
              {{
                $moment(vitalMeasurement.createdAt, "YYYY-MM-DD HH:mm:ss ZZ")
                  | moment("DD/MM/YYYY HH:mm")
              }}
            </v-col>
          </v-row>

          <v-divider />

          <v-row align="center">
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Pressão arterial
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto">
                  {{ vitalMeasurement.systolicBloodPressure }} X
                  {{ vitalMeasurement.diastolicBloodPressure }} mmHg
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Pulso
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto"> {{ vitalMeasurement.pulseRate }} bpm </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Temperatura
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto"> {{ vitalMeasurement.temperature }} °C </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Glicemia
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto"> {{ vitalMeasurement.glucoseLevel }}  mg/dL</v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Oximetria
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto"> {{ vitalMeasurement.oximetry }}  SpO2</v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Frequência respiratória
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto"> {{ vitalMeasurement.respiratoryRate }}  ipm</v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Dor no olho
                </v-col>
              </v-row>

              <v-row dense>
                <v-col >
                  {{ vitalMeasurement.eyePain ? "Sim" : "Não" }}
                </v-col>
              </v-row>
            </v-col>

            <v-col v-if="vitalMeasurement.painLevel">
              <v-row dense>
                <v-col class="font-weight-bold">
                  Escala da dor
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto">
                  {{ vitalMeasurement.painLevel }}
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <authorization
                permissionKey="attendance_surgery"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      :attrs="attrs"
                      v-on="on"
                      @click="deleteSurgeryVitalMeasurement"
                      v-if="authorization"
                      :disabled="disabled"
                    >
                      <v-icon>eva-trash-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Excluir
                  </span>
                </v-tooltip>
              </authorization>
            </v-col>
          </v-row>
          <v-row v-if="vitalMeasurement">
                <v-col>
                  {{ vitalMeasurement.observation }}
                </v-col>
              </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "SurgeryVitalMeasurementListItem",
    props: {
      vitalMeasurement: Object,
      refreshSurgery: Function,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      deleteSurgeryVitalMeasurement() {
        if (this.disabled) return;

        return this.apolloMutate({
          mutation: require("@/graphql/surgery/delete_surgery_vital_measurement.gql"),
          variables: {
            surgeryVitalMeasurementId: this.vitalMeasurement.id,
          },
        }).then(() => {
          this.refreshSurgery();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
